<template>
   <div v-if="loading" class="spinner-container">
      <div class="spinner"></div>
    </div>
    <div v-else>
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary">
            <div class="d-flex align-items-center">
         
              <span @click="goBack()" class="text-white"><i class="bi bi-arrow-left fs-5"></i></span> &nbsp; &nbsp;

                  <span>
                     <h4 class="text-white">{{language?.menu_cost}}</h4>
                  </span>
         
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                
                 <a href="#" class="link-dark text-truncate d-flex align-items-center gap-2" data-bs-toggle="offcanvas" data-bs-target="#cost"
                  aria-controls="cost">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-plus  d-flex m-1 h4 text-white"></i>
                  </b>
                  </a>
               </div>
            </div>
            



         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100">
          <div class="card-header d-flex justify-content-center p-2">
            <div class="col-12">
              <label for="products" class="form-label">{{language?.search_products}}</label>
              <input type="text"   v-model="search_txt" class="form-control">
              <!-- <select class="form-select form-select-sm" id="products" ref="products" v-model="cost.products">
                  <option value=""></option>
                  <option value="All">ALL</option>
                  <option v-for="(item, index) in productsList" :key="index" :value="item.id">{{ item.name }}</option>
              </select> -->
          </div>
          
            </div>
            <!-- Top Evets -->
            <div class="pt-3 bg_card">
               
               <div class="row">
                  <!-- 1st item -->
                  <div class="">

                    <!-- <div class="card-title">
                      <span style="margin-left: 5px; font-weight: bold;">Product List</span>
                  </div> -->
                  
                    
                     <div class="card  border-1 overflow-hidden " v-for="(cost,i) in filteredproductsList">
                       
                                <div class="card-body">
                                   <!-- <b>{{branch.name}}</b> -->
                                   <div><i class="bi bi-bag"></i> <strong>{{ cost.name }}</strong></div>
                                   <div>{{cost.description}}</div>
                                </div> 
                            
                        <div
                           class="card-footer ">
                           <div>
                            <span class="badge bg-success" @click="addcart(cost.id)"><i class="bi bi-plus-square"></i> &nbsp;{{language?.manage}}</span> 
                                              
                              <!-- <span class="badge bg-success" @click="editcost(cost)"><i class="bi bi-pen"></i> &nbsp;Edit</span> &nbsp; &nbsp; 
                              <span class="badge bg-danger" @click="deletecost(cost.id)"><i class="bi bi-trash"></i> &nbsp; Delete</span> -->
                           </div>
                            
                        </div>

                     </div> 
                  </div> 
                  
               </div> 
            </div>

       


 


  
         </div>
         
                <div class="offcanvas offcanvas-end border-0" tabindex="-1" id="cost" aria-labelledby="costLabel">
                <div class="offcanvas-header bg-primary d-flex align-items-center justify-content-start gap-3">
                    <a href="#" data-bs-dismiss="offcanvas" aria-label="Close"><i class="bi bi-arrow-left fs-5 text-white"></i></a>
                    <h6 class="offcanvas-title text-white m-0" id="costLabel">{{language?.create_new_cost}}</h6>
                </div>
                <div class="offcanvas-body">
                
                
                 
                          <div class="col-md-3">
                            <label for="services" class="form-label">{{language?.search_services}}</label>
                            <select class="form-select form-select-sm" id="services" ref="services" v-model="cost.servicesid">
                                <option value=""></option>
                                <option v-for="(item, index) in servicesList" :key="index" :value="item.id">{{ item.name }}</option>
                            </select>
                          </div>
                          

                    <div class="mb-3">
                     <label for="cost" class="form-label">{{language?.cost}}</label>
                     <input type="number" id="cost" v-model="cost.costs" class="form-control" required>
                 </div>

        
                    <div class="d-flex gap-2">
                    <button class="btn btn-primary w-100 " @click="addcost">{{language?.save}}</button>
                    <button class="btn btn-secondary w-50" @click="goprevious">{{language?.back}}</button>
                    </div>

                     
                    <div class="card  border-1 overflow-hidden " v-for="(cost,i) in filteredproductsCostList">
                       
                      <div class="card-body">
                         <!-- <b>{{branch.name}}</b> -->
                         <div><i class="bi bi-bag"></i> <strong>{{ cost.service_name }}</strong></div>
                         <div>{{cost.cost}}</div>
                      </div> 
                  
              <div
                 class="card-footer ">
                 <div>
                  <span class="badge bg-success" @click="editCost(cost)"><i class="bi bi-plus-square"></i> &nbsp;Edit</span> 
                                  
                   </div>
                </div>
             
              </div>
                 
         </div>
      </div>
      </div>
    </div>
</template>
  
<script> 
import axios from "@/plugins/axios";  

export default {
  name: 'Branch',
  components: { 
  },
  mounted() { 
   //  this.fetchWeather();
   this.getcosts(); // Call the method here
    
},
watch: {
    search_txt(newVal) {
      this.filteredproductsList = this.productsList.filter((item) =>
        item.name.toLowerCase().includes(newVal.toLowerCase())
      );
    },
  },
  data() {
    return { 
      loading:false,
      error:null,
      isUserLogged:false,
      user_details:[],
      productsList:[],
      productsCostList:[],
      filteredproductsCostList:[],
      language:this.getLocalStorageArray('lang'),
      filteredproductsList:[],
      cost:{
        costs:'',
        servicesid:'',
        productid:'',
      },
      search_txt:'',
      costs:[], 
      branch_name:''

    }
  },
  methods:{
    initializeHomeContent(){
    

    },
 
    goBack() {
          
          this.$router.go(-1);
  },
  goprevious() {
          
          this.$router.go("/cost");
  },
 
 
    async getcosts() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("getcosts").then((response) => {
               self.productsCostList=response.data.cost;
               self.servicesList=response.data.servicesLists;
               self.productsList=response.data.productsLists;
               self.filteredproductsList=self.productsList;
               self.language=response.data.language;
               localStorage.setItem('lang',response.data.language);
        
          }).then(() => {
               self.initializeHomeContent();


               $("#services").select2({
                        width: '250px', 
                        placeholder:"Search Services Here...",
                    "language": {
                                "noResults": function(){
                                    return "No Results Found <a href='#' class='btn btn-danger'>Use it anyway</a>";
                                }
                            },
                                escapeMarkup: function (markup) {
                                    return markup;
                                }
                    }).on('change', function (event) {
                    
                            
                        });

                     







          }).catch((err) => {
            
          });;
         

        } catch (err) {
          this.error = err.response?.data?.message || "Login failed. Please try again.";
        } finally {
          this.loading = false;
        }
      }, 





      addcost() {
        this.loading = true;
        this.error = null;
  
        try {
           var self=this;
            axios.post("addcost",self.cost).then((response) => {
              
                          self.productsList=response.data.productsLists;
                          self.filteredproductsList=self.productsList;
                     
                        self.$swal.fire(response.data.message);
                        if(response.data.success)
                        {
                            self.cost={ name:'',         description:''};
                        }
                      window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).hide();
                      

               
        
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    
                });;
                

                } catch (err) {
                this.error = err.response?.data?.message || "Login failed. Please try again.";
                } finally {
                this.loading = false;
                }
            }, 

              addcart(product_id) {
                this.filteredproductsCostList = this.productsCostList.filter((item) =>
                  item.productid==product_id
                );

                
                this.cost.productid = product_id; // Set the productid dynamically
                window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).show();
            // this.cost=editcost;
            }, 


            editCost(_cost) {
              
              this.cost.id=_cost.id;
              this.cost.costs=_cost.cost;
              this.cost.servicesid=_cost.servicesid;
              // window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).show();
              
          }, 
   




      deletecost(id = "") {
    this.loading = true;
    this.error = null;

    try {
        var self = this;

        this.$swal.fire({
            title: "Are you sure?",
            text: "You won't be able to revert this!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#3085d6",
            confirmButtonText: "Yes, delete it!",
            cancelButtonText: "No, cancel",
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post("deletecost", { id: id }).then((response) => {
                    self.costs=response.data.cost;
                    self.$swal.fire(response.data.message);
                    
                    if (response.data.success) {
                        window.bootstrap.Offcanvas.getOrCreateInstance(document.getElementById("cost")).hide();
                    }
                }).then(() => {
                    self.initializeHomeContent();
                }).catch((err) => {
                    self.$swal.fire("Error!", "Something went wrong.", "error");
                });
            }
        });

    } catch (err) {
        this.error = err.response?.data?.message || "Login failed. Please try again.";
    } finally {
        this.loading = false;
    }
},


getLocalStorageArray(key) {
        let data = localStorage?.getItem(key);
        try {
            return data ? JSON.parse(data) : [];
        } catch (e) {
            console.error("Error parsing localStorage data", e);
            return [];
        }
    }




  }
}






</script>
